import {PipeTransform, Pipe} from '@angular/core'
import {DomSanitizer, SafeHtml} from '@angular/platform-browser'

@Pipe({
  name: 'highlight',
  standalone: false,
})
export class HighlightPipe implements PipeTransform {
  constructor(public sanitizer: DomSanitizer) {}
  transform(
    text: string,
    search,
    minFilterLength = 1,
    anchorClass = '',
  ): SafeHtml {
    if (search && text && search.length >= minFilterLength) {
      let pattern = search.replace(
        /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,
        '\\$&',
      )
      pattern = pattern
        .split(' ')
        .filter((t) => {
          return t.length > 0
        })
        .join('|')
      const regex = new RegExp(pattern, 'gi')
      return this.sanitizer.bypassSecurityTrustHtml(
        text.replace(
          regex,
          (match) =>
            `<span class="search-highlight ${anchorClass}">${match}</span>`,
        ),
      )
    } else {
      return text
    }
  }
}
